var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-list-and-user-input"},[_c('MessageList'),(_vm.isOperatorOnline && !_vm.hasSupportResponded)?_c('div',{staticClass:"p-3 text-grey-2 bg-white-pure text-xs font-sans"},[_vm._v("A customer service agent is now active and will respond shortly.")]):_vm._e(),_c('UserInput')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }